export default __webpack_public_path__ + "862c6bed4fe87e82079f1a6b19aa4540.svg";